const Loader = () => <div className="loader" role="status"><div /></div>;
export default Loader; 